import { createReducer } from '../../../../../utils/ReduxUtils';
import * as types from '../../../actionTypes';

/**
 * @typedef {Record<string, boolean>} UserUiSelectSearchingReducer
 */

/** @type {UserUiSelectSearchingReducer} */
const initialState = {};

const isSearching = (state, { meta }) => {
  const { selectId, isSearching: searching } = meta;
  if (selectId) {
    return { ...state, [selectId]: searching };
  }
  return state;
};

export default createReducer(initialState, {
  [types.FETCH_USERS_SUCCESS]: isSearching,
});
